import Placeholder from "./_markup/Placeholder";
import Close from "./_markup/Close";
import AwardStar from "./_markup/AwardStar";
import Clean from "./_markup/Clean";
import Error from "./_markup/Error";
import FoodTray from "./_markup/FoodTray";
import GridDividers from "./_markup/GridDividers";
import FurnitureRecycle from "./_markup/FurnitureRecycle";
import HandHoldingDollar from "./_markup/HandHoldingDollar";
import HandFreeShopping from "./_markup/HandFreeShopping";
import HomeDashStar from "./_markup/HomeDashStar";
import Facebook from "./_markup/Facebook";
import Instagram from "./_markup/Instagram";
import Linkedin from "./_markup/Linkedin";
import YouTube from "./_markup/YouTube";
import Tripadvisor from "./_markup/Tripadvisor";
import RecyclingTriangle from "./_markup/RecyclingTriangle";
import SustainableIdeas from "./_markup/SustainableIdeas";
import SustainableChoice from "./_markup/SustainableChoice";
import WaterRecycle from "./_markup/WaterRecycle";
import Rent from "./_markup/Rent";
import Route from "./_markup/Route";
import Success from "./_markup/Success";
import Warning from "./_markup/Warning";
import Security from "./_markup/Security";
import SignsDirection from "./_markup/SignsDirection";
import Store from "./_markup/Store";
import UserStar from "./_markup/UserStar";
import UsersGroup from "./_markup/UsersGroup";
import Check from "./_markup/Check";
import Microphone from "./_markup/Microphone";
import Plus from "./_markup/Plus";
import ArrowLeft from "./_markup/ArrowLeft";
import ArrowRight from "./_markup/ArrowRight";
import DragHandler from "./_markup/DragHandler";
import RecyclingTag from "./_markup/RecyclingTag";
import World from "./_markup/World";
import ShoppingCart from "./_markup/ShoppingCart";
import User from "./_markup/User";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Placeholder,
  Close,
  AwardStar,
  Clean,
  Error,
  FoodTray,
  GridDividers,
  FurnitureRecycle,
  HandHoldingDollar,
  HandFreeShopping,
  HomeDashStar,
  Facebook,
  Instagram,
  Linkedin,
  YouTube,
  Tripadvisor,
  RecyclingTriangle,
  RecyclingTag,
  SustainableIdeas,
  SustainableChoice,
  WaterRecycle,
  Rent,
  Route,
  Success,
  Warning,
  Security,
  SignsDirection,
  Store,
  UserStar,
  UsersGroup,
  Check,
  Microphone,
  Plus,
  ArrowLeft,
  ArrowRight,
  DragHandler,
  World,
  ShoppingCart,
  User
};
